import fetchClient from '../utils/fetchClient';

export const spinEnergyAPI = {
    // Получить статус крутки
    getSpinStatus: async () => {
        const response = await fetchClient.get('/user-game-data/spin-status');
        return response;
    },

    // Начать крутку (ускорение восстановления ×5)
    startSpin: async () => {
        const response = await fetchClient.post('/user-game-data/spin-energy', {
            action: "start"
        });
        return response;
    },

    // Остановить крутку
    stopSpin: async () => {
        const response = await fetchClient.post('/user-game-data/spin-energy', {
            action: "stop"
        });
        return response;
    },

    // Legacy — для совместимости (перенаправляет на start)
    spinEnergy: async (spinData) => {
        const response = await fetchClient.post('/user-game-data/spin-energy', {
            action: "start"
        });
        return response;
    },

    // Получить полный статус энергии с круткой
    getEnergyStatus: async () => {
        const response = await fetchClient.get('/user-game-data/energy-status');
        return response;
    }
};
